// import React from 'react';
// import Breadcrumb from '../../../../components/Shared/Breadcrumb';
// import { Form } from 'react-bootstrap';
// import * as Yup from 'yup';
// import { useTranslation } from 'react-i18next';
// import { useAppDispatch } from '../../../../store/hooks';
// import { useFormik } from 'formik';
// import useGetChartAccountsDetailsList from '../../../../hooks/Finance/useGetChartAccountsDetailsList';
// import {type  ChartAccountsDetailsModels } from '../../../../store/Finance/ChartAccounts/ChartAccountsModels';
// import {
//   AddGlChartOfAccountsDetails,
//   UpdatGlChartOfAccountsDetails,
// } from '../../../../store/Finance/ChartAccounts/ChartAccountsDetailsSlice';
// import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
// import { Card, CardFooter, CardHeader } from '../../../../components/card/card';

// type Props = {
//   treeDetails: ChartAccountsDetailsModels;
//   breadcrumb: any[];
//   isAdd: boolean;
// };

// const CostCentersForm: React.FC<Props> = ({ treeDetails, breadcrumb, isAdd }) => {
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();
//   const { ChartAccountsDetailsList: data } = useGetChartAccountsDetailsList();

//   //#region GetNextAccountNumber

//   function getAccountLevelNumber(accountNumber: any) {
//     // تحديد المستوى بناءً على محتوى الرقم
//     let firstTwoDigits = accountNumber.substring(0, 2);
//     let fourthDigit = accountNumber.charAt(3);
//     let fifthDigit = accountNumber.charAt(4);

//     if (fourthDigit !== '0' && fifthDigit !== '0') {
//       // المستوى الثالث
//       return 3;
//     } else if (fourthDigit !== '0') {
//       // المستوى الثاني
//       return 2;
//     } else {
//       // المستوى الأول
//       return 1;
//     }
//   }

//   function getNextAccountNumber(item: ChartAccountsDetailsModels) {
//     console.log(item);

//     let level = getAccountLevelNumber(item.accountNumber);

//     const filteredAccounts = data?.filter(
//       (account) => account.accountParant === item.id && account.accountType !== 'Future'
//     );
//     // Find the maximum account number among the children
//     const maxAccountNumber = filteredAccounts.reduce((max, account) => {
//       const accountNumber = parseInt(account.accountNumber);
//       return accountNumber > max ? accountNumber : max;
//     }, 0);

//     if (item.accountType === 'CostCenter' && level === 1) {
//       if (maxAccountNumber === 0 && filteredAccounts?.length === 0) {
//         // تحويل item.accountNumber إلى سلسلة حتى نتمكن من التعامل مع الأرقام بشكل صحيح
//         let newAccountNumber = item.accountNumber.split('');
//         // تغيير الرقم الرابع إلى 1
//         newAccountNumber[3] = '1';
//         // إعادة الرقم الجديد كرقم
//         return newAccountNumber.join('');
//       }

//       // // Increment the maximum account number by 1
//       const nextAccountNumber = (maxAccountNumber + 10).toString().padStart(5, '0');
//       return nextAccountNumber;
//     } else if (item.accountType === 'CostCenter' && level === 2) {
//       if (maxAccountNumber === 0 && filteredAccounts?.length === 0) {
//         // تحويل item.accountNumber إلى سلسلة حتى نتمكن من التعامل مع الأرقام بشكل صحيح
//         let newAccountNumber = item.accountNumber.split('');
//         // تغيير الرقم الرابع إلى 1
//         newAccountNumber[4] = '1';
//         // إعادة الرقم الجديد كرقم
//         return newAccountNumber.join('');
//       }

//       // // Increment the maximum account number by 1
//       const nextAccountNumber = (maxAccountNumber + 1).toString().padStart(5, '0');
//       return nextAccountNumber;
//     } else if (
//       item.accountType === 'CostCenters' &&
//       item.id.toUpperCase() === '7A5A0A0D-00D9-4B8F-9F6A-8EBE1F851B47'
//     ) {
//       if (maxAccountNumber === 0 && filteredAccounts?.length === 0) {
//         return '01000';
//       }

//       const nextAccountNumber = (maxAccountNumber + 1000).toString().padStart(5, '0');
//       return nextAccountNumber;
//     }
//   }
//   //#endregion

//   //#region GetNextAccountNumber

//   // function getAccountLevelNumber(accountNumber: string): number {
//   //   // Determine the level based on the account number content
//   //   const fourthDigit = accountNumber.charAt(3);
//   //   const fifthDigit = accountNumber.charAt(4);

//   //   if (fourthDigit !== '0' && fifthDigit !== '0') {
//   //     return 3; // Level 3
//   //   } else if (fourthDigit !== '0') {
//   //     return 2; // Level 2
//   //   } else {
//   //     return 1; // Level 1
//   //   }
//   // }

//   // function getNextAccountNumber(item: ChartAccountsDetailsModels): string {
//   //   console.log(item);

//   //   const level = getAccountLevelNumber(item.accountNumber);
//   //   const filteredAccounts = data?.filter(
//   //     (account) => account.accountParant === item.id && account.accountType !== 'Future'
//   //   );
//   //   const maxAccountNumber = filteredAccounts.reduce((max, account) => {
//   //     const accountNumber = parseInt(account.accountNumber, 10);
//   //     return accountNumber > max ? accountNumber : max;
//   //   }, 0);

//   //   if (filteredAccounts?.length === 0) {
//   //     return generateInitialAccountNumber(item.accountNumber, level);
//   //   }

//   //   const incrementValue = getIncrementValue(item.accountType, level, item.id);
//   //   const nextAccountNumber = (maxAccountNumber + incrementValue).toString().padStart(5, '0');
//   //   return nextAccountNumber;
//   // }

//   // function generateInitialAccountNumber(accountNumber: string, level: number): string {
//   //   const newAccountNumber = accountNumber.split('');
//   //   if (level === 1) {
//   //     newAccountNumber[3] = '1';
//   //   } else if (level === 2) {
//   //     newAccountNumber[4] = '1';
//   //   }
//   //   return newAccountNumber.join('');
//   // }

//   // function getIncrementValue(accountType: string, level: number, id: string): number {
//   //   if (accountType === 'CostCenter') {
//   //     return level === 1 ? 10 : 1;
//   //   } else if (accountType === 'CostCenters' && id.toUpperCase() === '7A5A0A0D-00D9-4B8F-9F6A-8EBE1F851B47') {
//   //     return 1000;
//   //   }
//   //   return 1;
//   // }

//   //#endregion

//   //#region
//   const formik = useFormik({
//     initialValues: {
//       id: isAdd ? null : treeDetails ? treeDetails.id : '',
//       name: isAdd ? '' : treeDetails?.name || '',
//       name2: isAdd ? '' : treeDetails?.name || '',

//       chartOfAccountsId: treeDetails ? treeDetails.chartOfAccountsId : '',
//       accountNumber: isAdd ? getNextAccountNumber(treeDetails) : treeDetails?.accountNumber || '',
//       accountParant: isAdd ? treeDetails?.id || '' : treeDetails?.accountParant || '',

//       accountType: isAdd ? 'CostCenter' : treeDetails?.accountType, // 'CostCenter' sبدون حرف الـ

//       enabledFlag: treeDetails ? treeDetails.enabledFlag : false, // تفعيل وغير تفعيل

//       secondaryFlag: true, //
//       primaryParant: null, //
//       budgetingAllowedFlag: false, // لا احتاجه في هذا الفورم .. في الحسابات فقط
//       currencyCode: null, // لا احتاجه في هذا الفورم .. في الحسابات فقط
//       accountlevel: null, // لا احتاجه في هذا الفورم .. في الحسابات فقط
//     },

//     enableReinitialize: true,
//     validationSchema: validationSchema,

//     onSubmit: (values) => {
//       const requestBody = {
//         id: values.id,
//         name: values.name,
//         name2: values.name2,
//         chartOfAccountsId: values.chartOfAccountsId,
//         accountNumber: values.accountNumber,
//         accountParant: values.accountParant,
//         accountType: values.accountType,
//         secondaryFlag: values.secondaryFlag,
//         primaryParant: values.primaryParant,
//         // sequenceNum: values.sequenceNum,
//         budgetingAllowedFlag: values.budgetingAllowedFlag,
//         currencyCode: '',
//         enabledFlag: values.enabledFlag,
//         accountlevel: values.accountlevel,
//       };

//       const actionToDispatch = isAdd
//         ? AddGlChartOfAccountsDetails(requestBody)
//         : UpdatGlChartOfAccountsDetails(requestBody);

//       dispatch(actionToDispatch)
//         .unwrap()
//         .then((res) => {
//           if (res?.succeeded === true) {
//             CustomAlert({ action: isAdd ? 'Add' : 'Edit' });
//           } else {
//             formik.setSubmitting(false);
//             CustomAlert({ action: 'Error' });
//           }
//         })
//         .catch((error: any) => {
//           formik.setSubmitting(false);
//           CustomAlert({ action: 'Error' });
//         });
//     },
//   });
//   //#endregion

//   return (
//     <div>
//       <Card>
//         <CardHeader className="p-0">
//           <div className=" d-flex rounded-0  bg-theme bg-opacity-25  px-3 pt-2">
//             <div className="flex-grow-1">
//               <Breadcrumb
//                 BreadcrumbList={breadcrumb}
//                 subtitle={breadcrumb[breadcrumb?.length - 1]?.name}
//               />
//             </div>
//             {isAdd && <>اضافة مركز تكلفة جديد</>}
//           </div>
//         </CardHeader>
//         <Form onSubmit={formik.handleSubmit} className="bg-inverse bg-opacity-5 rounded-3 p-3">
//           <div className="row mb-2">
//             <div className="col-xl-5 m-auto text-center rounded-4 p-2 bg-inverse bg-opacity-10 ">
//               <label className="form-label">رقم الحساب</label>
//               <div className="text-theme fw-bold fs-4">{formik.values.accountNumber}</div>
//             </div>

//             <div className="col-xl-5 m-auto  text-center rounded-4 p-2 bg-inverse bg-opacity-10">
//               <label className="form-label "> الحسـاب الرئيسي </label>
//               <div className="text-theme fw-bold fs-4">
//                 {data?.find((f) => formik.values.accountParant === f.id)?.name2 || '.'}
//               </div>
//             </div>
//           </div>

//           <hr />

//           <div className="row">
//             <div className="col-xl-5">
//               <div className="form-group mb-3">
//                 <label className="form-label">الأسم المحلي</label>
//                 <Form.Control
//                   className="form-control"
//                   type="text" 
// autoComplete='off'
//                   name="name2"
//                   onChange={formik.handleChange}
//                   value={formik.values.name2 || ''}
//                   isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
//                   isValid={formik.touched.name2 && !formik.errors.name2}
//                 />
//                 <Form.Control.Feedback type="invalid">{formik.errors.name2}</Form.Control.Feedback>
//                 <Form.Control.Feedback type="valid">
//                   {formik.touched.name2 && !formik.errors.name2}
//                 </Form.Control.Feedback>
//               </div>
//             </div>
//             <div className="col-xl-5">
//               <div className="form-group mb-3">
//                 <label className="form-label">الأسم العالمي</label>
//                 <Form.Control
//                   className="form-control"
//                   type="text" 
// autoComplete='off'
//                   name="name"
//                   onChange={formik.handleChange}
//                   value={formik.values.name || ''}
//                   isInvalid={!!(formik.touched.name && formik.errors.name)}
//                   isValid={formik.touched.name && !formik.errors.name}
//                 />
//                 <Form.Control.Feedback type="invalid">{formik.errors.name}</Form.Control.Feedback>
//                 <Form.Control.Feedback type="valid">
//                   {formik.touched.name && !formik.errors.name}
//                 </Form.Control.Feedback>
//               </div>
//             </div>
//             <div className="col-xl-2">
//               <div className="form-group mb-3">
//                 <label className="form-label" style={{ margin: '0px 22px' }}>
//                   {t('Active')}
//                 </label>
//                 <Form.Check
//                   className="ps-5"
//                   style={{ margin: '10px 20px' }}
//                   type="checkbox"
//                   label=""
//                   name="enabledFlag"
//                   onChange={formik.handleChange}
//                   checked={formik.values.enabledFlag}
//                 />
//               </div>
//             </div>
//           </div>

//           {/* <div className="row">

//             <div className="col-xl-4">
//               <div className="form-group mb-3">
//                 <label className="form-label">رقم الحساب</label>
//                 <div className="input-group flex-nowrap">
//                   <Form.Control
//                     disabled
//                     className="form-control text-center"
//                     type="text" 
// autoComplete='off'
//                     name="accountNumber"
//                     onChange={formik.handleChange}
//                     value={formik.values.accountNumber || ''}
//                     isInvalid={!!(formik.touched.accountNumber && formik.errors.accountNumber)}
//                   />
//                 </div>
//               </div>
//             </div>

//             <div className="col-xl-6">
//               <div className="form-group mb-3">
//                 <label className="form-label"> الحسـاب الرئيسي </label>
//                 <Form.Select
//                   disabled
//                   className="form-select"
//                   name="accountParant"
//                   onChange={formik.handleChange}
//                   value={formik.values.accountParant || ''}
//                   isInvalid={!!(formik.touched.accountParant && formik.errors.accountParant)}>
//                   <option value="">{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                   {data &&
//                     data?.map((item, idx) => (
//                       <option key={++idx} value={item.id}>
//                         {i18n.language === 'en' ? item.name : item.name2}
//                       </option>
//                     ))}
//                 </Form.Select>
//               </div>
//             </div>

//             <div className="col-xl-2">
//               <div className="form-group mb-3">
//                 <label className="form-label" style={{ margin: '0px 22px' }}>
//                   {t('Active')}
//                 </label>
//                 <Form.Check
//                   className="ps-5"
//                   style={{ margin: '10px 20px' }}
//                   type="checkbox"
//                   label=""
//                   name="enabledFlag"
//                   onChange={formik.handleChange}
//                   checked={formik.values.enabledFlag}
//                 />
//               </div>
//             </div>
//           </div> */}

//           <CardFooter className=" bg-theme bg-opacity-10">
//             <div className="text-center">
//               {!isAdd && (
//                 <button
//                   disabled={formik.isSubmitting || !treeDetails.enabledFlag}
//                   type="submit"
//                   className="btn me-1 btn-theme mb-1">
//                   {formik.isSubmitting ? (
//                     <div className="spinner-border spinner-border-sm me-2"></div>
//                   ) : (
//                     <i className="fa fa-save fa-fw me-2"></i>
//                   )}
//                   {t('Edit')}
//                 </button>
//               )}

//               {isAdd && (
//                 <button
//                   disabled={formik.isSubmitting}
//                   type="submit"
//                   className="btn me-1 btn-theme mb-1">
//                   {formik.isSubmitting ? (
//                     <div className="spinner-border spinner-border-sm me-2"></div>
//                   ) : (
//                     <i className="fas fa-lg fa-fw me-2 fa-plus"></i>
//                   )}
//                   {t('Add')}
//                 </button>
//               )}
//             </div>
//           </CardFooter>
//         </Form>
//       </Card>
//     </div>
//   );
// };

// export default CostCentersForm;

// const validationSchema = Yup.object().shape({
//   name: Yup.string().required('*'),
//   name2: Yup.string().required('*'),
// });


import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Form } from 'react-bootstrap';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../../store/hooks';
import { useFormik } from 'formik';
import useGetChartAccountsDetailsList from '../../../../hooks/Finance/useGetChartAccountsDetailsList';
import { type ChartAccountsDetailsModels } from '../../../../store/Finance/ChartAccounts/ChartAccountsModels';
import {
  AddGlChartOfAccountsDetails,
  GetGlChartOfAccountsDetailsList,
  UpdatGlChartOfAccountsDetails
} from '../../../../store/Finance/ChartAccounts/ChartAccountsDetailsSlice';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import { Card, CardFooter, CardHeader } from '../../../../components/card/card';

type Props = {
  treeDetails: ChartAccountsDetailsModels;
  breadcrumb: any[];
  isAdd: boolean;
};

const COST_CENTERS_ROOT_ID = '7A5A0A0D-00D9-4B8F-9F6A-8EBE1F851B47';

const safeAcc = (v: any) => String(v ?? '').padStart(5, '0');
const safeInt = (v: any) => {
  const n = parseInt(String(v ?? '').replace(/\D/g, ''), 10);
  return Number.isFinite(n) ? n : 0;
};

function getAccountLevelNumber(accountNumber: any) {
  const x = safeAcc(accountNumber);
  const fourthDigit = x.charAt(3);
  const fifthDigit = x.charAt(4);

  if (fourthDigit !== '0' && fifthDigit !== '0') return 3;
  if (fourthDigit !== '0') return 2;
  return 1;
}

const CostCentersForm: React.FC<Props> = ({ treeDetails, breadcrumb, isAdd }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { ChartAccountsDetailsList: data } = useGetChartAccountsDetailsList();

  const getNextAccountNumber = useCallback(
    (item: ChartAccountsDetailsModels): string => {
      const children = (data ?? []).filter(
        a => a.accountParant === item.id && a.accountType !== 'Future'
      );

      const maxAccountNumber = children.reduce((max, a) => {
        const n = safeInt(a.accountNumber);
        return n > max ? n : max;
      }, 0);

      const level = getAccountLevelNumber(item.accountNumber);

      // إضافة "مركز تكلفة" جديد تحت الجذر CostCenters (Level 1)
      if (item.accountType === 'CostCenters' && String(item.id).toUpperCase() === COST_CENTERS_ROOT_ID) {
        if (children.length === 0) return '01000';
        return (maxAccountNumber + 1000).toString().padStart(5, '0');
      }

      // إضافة ابن تحت مركز تكلفة (Level 2/3 حسب رقم الأب)
      if (item.accountType === 'CostCenter' && level === 1) {
        if (children.length === 0) {
          const s = safeAcc(item.accountNumber).split('');
          s[3] = '1';
          return s.join('');
        }
        return (maxAccountNumber + 10).toString().padStart(5, '0');
      }

      if (item.accountType === 'CostCenter' && level === 2) {
        if (children.length === 0) {
          const s = safeAcc(item.accountNumber).split('');
          s[4] = '1';
          return s.join('');
        }
        return (maxAccountNumber + 1).toString().padStart(5, '0');
      }

      return '';
    },
    [data]
  );

  const formik = useFormik({
    initialValues: {
      id: isAdd ? null : treeDetails?.id ?? '',
      name: isAdd ? '' : treeDetails?.name ?? '',
      name2: isAdd ? '' : treeDetails?.name2 ?? '',

      chartOfAccountsId: treeDetails?.chartOfAccountsId ?? '',
      // مهم: لا نحسب الرقم هنا (حتى لا يعاد حسابه مع enableReinitialize)
      accountNumber: isAdd ? '' : treeDetails?.accountNumber ?? '',
      accountParant: isAdd ? treeDetails?.id ?? '' : treeDetails?.accountParant ?? '',

      accountType: isAdd ? 'CostCenter' : treeDetails?.accountType ?? 'CostCenter',

      enabledFlag: isAdd ? true : (treeDetails?.enabledFlag ?? false),

      secondaryFlag: true,
      primaryParant: null,
      budgetingAllowedFlag: false,
      currencyCode: null,
      accountlevel: null
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: values => {
      const requestBody = {
        id: values.id,
        name: values.name,
        name2: values.name2,
        chartOfAccountsId: values.chartOfAccountsId,
        accountNumber: values.accountNumber,
        accountParant: values.accountParant,
        accountType: values.accountType,
        secondaryFlag: values.secondaryFlag,
        primaryParant: values.primaryParant,
        budgetingAllowedFlag: values.budgetingAllowedFlag,
        currencyCode: '',
        enabledFlag: values.enabledFlag,
        accountlevel: values.accountlevel
      };

      const actionToDispatch = isAdd
        ? AddGlChartOfAccountsDetails(requestBody)
        : UpdatGlChartOfAccountsDetails(requestBody);

      dispatch(actionToDispatch)
        .unwrap()
        .then(res => {
          if (res?.succeeded === true) {
            CustomAlert({ action: isAdd ? 'Add' : 'Edit' });
            dispatch(GetGlChartOfAccountsDetailsList());
          } else {
            CustomAlert({ action: 'Error' });
          }
        })
        .catch(() => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => {
          formik.setSubmitting(false);
        });
    }
  });

  // ✅ توليد رقم المركز مرة واحدة لكل أب (مثل AccountsForm)
  const autoGenRef = useRef<{ parentId: string | null; value: string | null }>({ parentId: null, value: null });

  useEffect(() => {
    if (!isAdd) {
      autoGenRef.current = { parentId: null, value: null };
      return;
    }

    const parentId = treeDetails?.id ?? null;
    if (!parentId) return;

    const next = getNextAccountNumber(treeDetails);
    if (!next) return;

    const current = String(formik.values.accountNumber ?? '');
    const prev = autoGenRef.current;

    const parentChanged = prev.parentId !== parentId;
    const isEmpty = !current;
    const isStillAuto = prev.value && current === prev.value;

    if (parentChanged || isEmpty || isStillAuto) {
      formik.setFieldValue('accountNumber', next, false);
      autoGenRef.current = { parentId, value: next };
    }
  }, [isAdd, treeDetails?.id, getNextAccountNumber, formik.values.accountNumber, treeDetails]);

  const parentName = useMemo(() => {
    if (!formik.values.accountParant) return '.';
    return (data ?? []).find(f => f.id === formik.values.accountParant)?.name2 ?? '.';
  }, [data, formik.values.accountParant]);

  return (
    <div>
      <Card>
        <CardHeader className="p-0">
          <div className="d-flex rounded-0 bg-theme bg-opacity-25 px-3 pt-2">
            <div className="flex-grow-1">
              <Breadcrumb BreadcrumbList={breadcrumb} subtitle={breadcrumb[breadcrumb?.length - 1]?.name} />
            </div>
            {isAdd && <>اضافة مركز تكلفة جديد</>}
          </div>
        </CardHeader>

        <Form onSubmit={formik.handleSubmit} className="bg-inverse bg-opacity-5 rounded-3 p-3">
          <div className="row mb-2">
            <div className="col-xl-5 m-auto text-center rounded-4 p-2 bg-inverse bg-opacity-10 ">
              <label className="form-label">رقم المركز</label>
              <div className="text-theme fw-bold fs-4">{formik.values.accountNumber}</div>
            </div>

            <div className="col-xl-5 m-auto text-center rounded-4 p-2 bg-inverse bg-opacity-10">
              <label className="form-label">المركز الرئيسي</label>
              <div className="text-theme fw-bold fs-4">{parentName}</div>
            </div>
          </div>

          <hr />

          <div className="row">
            <div className="col-xl-5">
              <div className="form-group mb-3">
                <label className="form-label">الأسم المحلي</label>
                <Form.Control
                  className="form-control"
                  type="text"
                  autoComplete="off"
                  name="name2"
                  onChange={formik.handleChange}
                  value={formik.values.name2 || ''}
                  isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
                  isValid={formik.touched.name2 && !formik.errors.name2}
                />
                <Form.Control.Feedback type="invalid">{formik.errors.name2}</Form.Control.Feedback>
              </div>
            </div>

            <div className="col-xl-5">
              <div className="form-group mb-3">
                <label className="form-label">الأسم العالمي</label>
                <Form.Control
                  className="form-control"
                  type="text"
                  autoComplete="off"
                  name="name"
                  onChange={formik.handleChange}
                  value={formik.values.name || ''}
                  isInvalid={!!(formik.touched.name && formik.errors.name)}
                  isValid={formik.touched.name && !formik.errors.name}
                />
                <Form.Control.Feedback type="invalid">{formik.errors.name}</Form.Control.Feedback>
              </div>
            </div>

            <div className="col-xl-2">
              <div className="form-group mb-3">
                <label className="form-label" style={{ margin: '0px 22px' }}>
                  {t('Active')}
                </label>
                <Form.Check
                  className="ps-5"
                  style={{ margin: '10px 20px' }}
                  type="checkbox"
                  label=""
                  name="enabledFlag"
                  onChange={formik.handleChange}
                  checked={!!formik.values.enabledFlag}
                />
              </div>
            </div>
          </div>

          <CardFooter className="bg-theme bg-opacity-10">
            <div className="text-center">
              {!isAdd && (
                <button
                  disabled={formik.isSubmitting || !treeDetails.enabledFlag}
                  type="submit"
                  className="btn me-1 btn-theme mb-1"
                >
                  {formik.isSubmitting ? (
                    <div className="spinner-border spinner-border-sm me-2"></div>
                  ) : (
                    <i className="fa fa-save fa-fw me-2"></i>
                  )}
                  {t('Edit')}
                </button>
              )}

              {isAdd && (
                <button disabled={formik.isSubmitting} type="submit" className="btn me-1 btn-theme mb-1">
                  {formik.isSubmitting ? (
                    <div className="spinner-border spinner-border-sm me-2"></div>
                  ) : (
                    <i className="fas fa-lg fa-fw me-2 fa-plus"></i>
                  )}
                  {t('Add')}
                </button>
              )}
            </div>
          </CardFooter>
        </Form>
      </Card>
    </div>
  );
};

export default CostCentersForm;

const validationSchema = Yup.object().shape({
  name: Yup.string().required('*').trim(),
  name2: Yup.string().required('*').trim(),
  accountNumber: Yup.string().required('*')
});
